import { FormControl, Grid, InputLabel, MenuItem, Modal, Select, Tab, Tabs } from "@mui/material";
import MDBox from "../../components/MDBox";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import React, { useEffect, useState } from "react";
import { updateDashboardUser, updateDashboardUserPassword } from "../../api/routes";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 4,
  p: 4,
};
export default function UpdateUserModal({ modal, handleClose, setTrigger }) {
  const [information, setInformation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInformation({ ...information, [name]: value });
  };
  useEffect(() => {
    if (modal?.data) {
      setInformation(modal?.data);
    }
  }, [modal?.data]);
  const submit = () => {
    if (tab === 0) {
      const { userId, username, ...restInformation } = information;
      setLoading(true);
      updateDashboardUser(userId, restInformation, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          toast.success("اطلاعات کاربر ویرایش شد!");
          setTrigger(Math.random());
          handleClose();
        }
      });
    } else {
      const data = {
        username: information.username,
        newPassword: information.password,
      };
      updateDashboardUserPassword(data, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          toast.success("اطلاعات کاربر ویرایش شد!");
          handleClose();
        }
      });
    }
  };
  return (
    <Modal open={modal.state} onClose={handleClose}>
      <MDBox sx={style}>
        <Loading loading={loading} />
        <Tabs value={tab} onChange={handleChangeTab} textColor="primary" indicatorColor="primary">
          <Tab value={0} label="ویرایش اطلاعات کلی" className="font-bold" />
          <Tab value={1} label="ویرایش رمز عبور" className="font-bold" />
        </Tabs>
        <Grid container rowGap={2} py={2} px={2}>
          {tab === 0 && <><Grid item xs={12} xl={12}>
            <MDInput fullWidth value={information.fullname} name="fullname" onChange={handleChange} type="text"
                     label="نام" />
          </Grid>
            <Grid item xs={12} xl={12}>
              <FormControl fullWidth>
                <InputLabel>نوع دسترسی</InputLabel>
                <Select label="نوع دسترسی" sx={{ height: "44.3px" }} value={information.role} name="role"
                        onChange={handleChange}>
                  <MenuItem value={"center"}>ادمین</MenuItem>
                  <MenuItem value={"reservation"}>نوبت دهی</MenuItem>
                  <MenuItem value={"reception"}>پذیرش</MenuItem>
                  <MenuItem value={"notebookReservation"}>دفتر نوبت دهی</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} xl={12}>
              <MDInput fullWidth disabled value={information.username} name="username" onChange={handleChange}
                       type="text"
                       label="نام کاربری" />
            </Grid>
          </>}
          {tab === 1 && <Grid item xs={12} xl={12}>
            <MDInput fullWidth value={information.password} name="password" onChange={handleChange} type="text"
                     label="رمزعبور" />
          </Grid>}
        </Grid>
        <MDButton onClick={submit} variant="gradient" color="info" fullWidth style={{ marginTop: 15 }}>
          ویرایش
        </MDButton>
      </MDBox>
    </Modal>
  );
}
